import { VIEW_PAGE, VIEW_BLOG } from '@confluence/named-routes/entry-points/routes.ts';

/** Route shape only: callers evaluate the experiment and kill switch inline. */
export function canDeferPageRestrictions({
	name,
	query = {},
}: {
	name: string;
	query?: Record<string, unknown>;
}): boolean {
	return (
		(name === VIEW_PAGE.name || name === VIEW_BLOG.name) &&
		!query.lite &&
		!query.versionOverride &&
		!query.version &&
		!query.draftId &&
		!query.draftShareId &&
		!query.embeddedContentRender &&
		!query.embedded &&
		!query.parentProduct
	);
}
